module.exports = __webpack_public_path__ + "static/media/weekday-day-games.b46e45b0.png";